import {technicalMapCardButtonsStackMq, technicalMapFilterActionsStackMq, technicalMapFilterNarrowMq} from './technicalMapBreakpoints';

const catalogTextSx = {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: 1.4,
    color: '#2C3038',
};

export const technicalMapFilterIconSx = {
    color: '#737478',
    fontSize: 24,
    width: 24,
    height: 24,
};

export const technicalMapFilterIconButtonSx = {
    width: 24,
    height: 24,
    padding: 0,
};

export const technicalMapFilterToggleButtonSx = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    minWidth: 40,
    height: 40,
    minHeight: 40,
    padding: 0,
    boxSizing: 'border-box',
    borderRadius: '8px',
    border: '1px solid #EAEBEA',
    color: '#737478',
    backgroundColor: 'transparent',
    cursor: 'pointer',
};

export const technicalMapFilterSectionSx = {
    boxSizing: 'border-box',
    width: '100%',
    padding: '12px 0 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
};

export const technicalMapFilterContentSx = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
};

export const technicalMapFilterRowSx = {
    display: 'grid',
    gridTemplateColumns: '100px minmax(0, 1fr)',
    columnGap: '12px',
    alignItems: 'center',
    width: '100%',
    [technicalMapCardButtonsStackMq]: {
        gridTemplateColumns: '1fr',
        rowGap: '8px',
        alignItems: 'stretch',
    },
};

export const technicalMapFilterRowLabelSx = {
    ...catalogTextSx,
    fontWeight: 600,
    lineHeight: 1.2,
    minWidth: 0,
    maxWidth: '100px',
    overflowWrap: 'normal',
    wordBreak: 'normal',
    flex: 1,
    [technicalMapCardButtonsStackMq]: {
        maxWidth: 'none',
    },
};

export const technicalMapFilterRowLabelCellSx = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
};

export const technicalMapFilterSortLeadingSx = {
    display: 'none',
    flexShrink: 0,
    [technicalMapFilterNarrowMq]: {
        display: 'flex',
    },
};

export const technicalMapFilterSortTrailingSx = {
    display: 'flex',
    flexShrink: 0,
    [technicalMapFilterNarrowMq]: {
        display: 'none',
    },
};

export const technicalMapFilterRowControlSx = {
    minWidth: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    [technicalMapFilterNarrowMq]: {
        alignItems: 'stretch',
    },
};

export const technicalMapFilterDateRowLabelDesktopSx = {
    [technicalMapCardButtonsStackMq]: {
        display: 'none',
    },
};

export const technicalMapFilterDateRowLabelMobileSx = {
    display: 'none',
    maxWidth: 'none',
    [technicalMapCardButtonsStackMq]: {
        display: 'block',
    },
};

export const technicalMapFilterBlockTitleSx = {
    fontSize: '18px',
    fontWeight: 600,
};

export const technicalMapFilterBlockSx = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
};

export const technicalMapFilterFieldSx = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        height: 40,
        '& .MuiOutlinedInput-input': {
            padding: '0 8px 0 12px',
            ...catalogTextSx,
        },
        '& fieldset': {
            border: '1px solid #EAEBEA',
            borderRadius: '8px',
        },
        '&:hover fieldset': {
            border: '1px solid #EAEBEA',
        },
        '&.Mui-focused fieldset': {
            border: '1px solid #EAEBEA',
            borderWidth: '1px',
        },
    },
};

export const technicalMapSearchFieldSx = {
    ...technicalMapFilterFieldSx,
    '& .MuiOutlinedInput-root.MuiInputBase-adornedStart': {
        paddingLeft: '8px',
    },
    '& .MuiOutlinedInput-root.MuiInputBase-adornedEnd': {
        paddingRight: '8px',
    },
    '& .MuiInputAdornment-root': {
        margin: 0,
        maxHeight: 'unset',
    },
    '& .MuiOutlinedInput-input': {
        padding: '0 8px',
        ...catalogTextSx,
    },
};

export const technicalMapRangeRowSx = {
    display: 'flex',
    flex: 1,
    minWidth: 0,
    columnGap: '8px',
    [technicalMapFilterNarrowMq]: {
        flexDirection: 'column',
        rowGap: '8px',
    },
};

export const technicalMapRangeFieldSx = {
    flex: 1,
    minWidth: 0,
    width: '100%',
};

export const technicalMapApplyFiltersButtonSx = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    minHeight: 44,
    padding: '0 16px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: (theme) => theme.palette.primary.main,
    color: 'white',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 1,
    cursor: 'pointer',
};

export const technicalMapResetFiltersButtonSx = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    minHeight: 44,
    padding: '0 16px',
    borderRadius: '8px',
    border: (theme) => `1px solid ${theme.palette.primary.main}`,
    backgroundColor: 'transparent',
    color: (theme) => theme.palette.primary.main,
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 1,
    cursor: 'pointer',
};

export const technicalMapFilterActionsSx = {
    display: 'flex',
    gap: '12px',
    marginBottom: '24px',
    [technicalMapFilterActionsStackMq]: {
        flexDirection: 'column',
    },
};

export const technicalMapMenuItemSx = {
    ...catalogTextSx,
    padding: '8px 16px',
    minHeight: 'unset',
    '&:hover': {
        backgroundColor: 'rgba(180, 184, 204, 0.18)',
    },
    '&.Mui-selected': {
        ...catalogTextSx,
        backgroundColor: 'rgba(180, 184, 204, 0.18)',
    },
    '&.Mui-selected:hover': {
        backgroundColor: 'rgba(180, 184, 204, 0.18)',
    },
    '&.Mui-focusVisible': {
        backgroundColor: 'rgba(180, 184, 204, 0.18)',
    },
};

export const technicalMapGroupingCheckboxSx = {
    m: 0,
    ml: 0,
    pl: 0,
    alignItems: 'center',
    '& .MuiCheckbox-root': {
        p: 0,
        mr: 0.5,
    },
    '& .MuiFormControlLabel-label': catalogTextSx,
};
